import { action } from 'typesafe-actions';

import { DrawerTypes } from './types';

// Drawer
export const setToggleDrawer = (payload: { open: boolean}) =>
  action(DrawerTypes.SET_TOGGLE_DRAWER, payload);
